// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Measurement_standardSize__6odMt {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.Measurement_part__HYu6Y {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  padding-bottom: 1rem;
  gap: 2rem;
}

.Measurement_img__4rvjL {
  display: flex;
  width: 38rem;
  justify-content: center;
  align-items: center;
  background-size: contain;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Measurement/Measurement.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;AADF;;AAGA;EACE,aAAA;EACA,kCAAA;EACA,oBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;AAAF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.standardSize {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n.part {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  padding-bottom: 1rem;\n  gap: 2rem;\n}\n\n.img {\n  display: flex;\n  width: 38rem;\n  justify-content: center;\n  align-items: center;\n  background-size: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"standardSize": `Measurement_standardSize__6odMt`,
	"part": `Measurement_part__HYu6Y`,
	"img": `Measurement_img__4rvjL`
};
export default ___CSS_LOADER_EXPORT___;
